import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { ASSETS } from "@/lib/assets";

export default function PaymentCancel() {
  return (
    <main className="min-h-[100svh] flex items-center justify-center px-6 py-24 relative" data-testid="payment-cancel">
      <div className="absolute inset-0 spotlight pointer-events-none" />
      <div className="relative z-10 w-full max-w-md ornate-frame bg-[var(--surface)] p-10 sm:p-14 text-center">
        <img src={ASSETS.crest} alt="" className="w-16 mx-auto mb-6 rounded-full" />
        <XCircle className="w-10 h-10 text-[var(--gold)] mx-auto" />
        <h1 className="font-display text-4xl text-[var(--cream)] mt-6">Booking cancelled</h1>
        <p className="font-serif-alt text-lg text-[var(--muted)] mt-4">
          No payment was taken. Your seat is still waiting whenever you're ready.
        </p>
        <Link
          to="/#book"
          data-testid="cancel-retry-link"
          className="inline-block mt-10 rounded-full bg-[var(--gold)] text-[var(--bg)] px-8 py-3 uppercase tracking-[0.2em] text-xs font-semibold hover:bg-[var(--cream)] transition-colors duration-300"
        >
          Try again
        </Link>
      </div>
    </main>
  );
}
